<template>
    <v-card>
        <v-card-title class="text-h5 grey lighten-2">
            {{termo.titulo}}
        </v-card-title>

        <v-card-text class="mt-3" v-html="termo.texto">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
         
        </v-card-actions>
    </v-card>
</template>

<script>
import { fetchPrivacyPolicy } from '../utils/privacidadePolicy';

export default {
    data() {
        return {
            termo: { titulo: "", texto: ""}
        }
    },
    async mounted() {
        this.termo = await fetchPrivacyPolicy(this.$http);
    }
}
</script>
